import { TableFilter, TableFilterFieldType } from 'shared/UI/UIKit/TableFilter';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppPagination } from 'shared/UI/UIKit/Pagination';
import { AppTable } from 'shared/UI/UIKit/Table';
import { TableColumnsFilter } from 'common/ColumnsFilter/ColumnsFilter';
import { useFilteredColumns } from 'common/ColumnsFilter/use-filtered-columns';
import {
  CreateClassGroupModal,
  DeleteClassGroupModal,
  GenerateClassGroupsModal,
} from 'entities/class-group';
import { useClassGroupsTable } from '../model';
import { useColumns } from './use-columns';
import styles from './styles.module.scss';

export const ClassGroupsTable = () => {
  const table = useClassGroupsTable();
  const columns = useColumns(table);
  const { state, lookups, methods } = table;

  const { filteredColumns, visibleKeys, setVisibleKeys } = useFilteredColumns(columns);
  const filterFields = [
    {
      key: 'educationalClassId',
      name: 'educationalClassId',
      label: 'Класс',
      type: TableFilterFieldType.SELECT,
      options: state.classOptions,
    },
    {
      key: 'subjectId',
      name: 'subjectId',
      label: 'Предмет',
      type: TableFilterFieldType.SELECT,
      options: state.subjectOptions,
    },
    {
      key: 'teacherId',
      name: 'teacherId',
      label: 'Преподаватель',
      type: TableFilterFieldType.SELECT,
      options: state.teacherOptions,
    },
  ];

  return (
    <>
      <AppFlex direction="row" wrap="wrap" justifyContent="flex-end" className={styles.controls}>
        <AppButton onClick={methods.showCreate}>Создать группу</AppButton>
        <AppButton type="outline" onClick={methods.showGenerate}>
          Массовое создание
        </AppButton>
        <TableFilter fields={filterFields} onFilterChange={methods.onFilterChange} />
        <TableColumnsFilter
          columns={columns}
          visibleKeys={visibleKeys}
          setVisibleKeys={setVisibleKeys}
        />
      </AppFlex>

      <AppTable
        rowKey={(group) => group.id}
        dataSource={state.groups}
        columns={filteredColumns}
        loading={state.loading}
        sorters={state.tableState.sorters}
        paginationVisible={false}
        onChange={methods.onTableChange}
        scroll={{ x: 'max-content' }}
      />
      <AppPagination
        className="ant-table-pagination ant-table-pagination-right"
        current={state.tableState.pagination.current}
        total={state.total}
        pageSize={state.tableState.pagination.pageSize}
        pageSizeOptions={state.tableState.pagination.pageSizeOptions}
        showSizeChanger
        showTotal={(total, range) => `${range[0]}-${range[1]} из ${total}`}
        onChange={methods.onPaginationChange}
        onShowSizeChange={methods.onPaginationChange}
      />

      <CreateClassGroupModal
        visible={state.createVisible}
        classOptions={state.classOptions}
        subjectOptions={state.subjectOptions}
        onClose={methods.hideCreate}
      />
      <GenerateClassGroupsModal
        visible={state.generateVisible}
        classOptions={state.classOptions}
        subjectOptions={state.subjectOptions}
        getClassName={lookups.getClassName}
        getSubjectName={lookups.getSubjectName}
        onClose={methods.hideGenerate}
      />
      <DeleteClassGroupModal
        group={state.deletingGroup}
        className={
          state.deletingGroup
            ? lookups.getClassName(state.deletingGroup.educationalClassId)
            : undefined
        }
        subjectName={
          state.deletingGroup ? lookups.getSubjectName(state.deletingGroup.subjectId) : undefined
        }
        onClose={methods.hideDelete}
        onSuccess={methods.onDeleteSuccess}
      />
    </>
  );
};
